exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*!\n* PASSWORD-STRENGTH-VALIDATOR COMPONENT STYLES\n*/.password-length{float:right;position:relative;bottom:24px;right:10px}.strength-meter-container span{color:#adacac;font-size:.9em}.strength-meter{position:relative;height:4px;background:#ddd;margin:3px 0 10px;border-radius:3px;max-width:400px}.strength-meter .strength-meter-fill{background:transparent;height:inherit;position:absolute;width:0;border-radius:inherit;transition:width .5s ease-in-out,background .25s}.strength-meter .strength-meter-fill[data-strength=\"0\"]{background:darkred;width:20%}.strength-meter .strength-meter-fill[data-strength=\"1\"]{background:#ff4500;width:40%}.strength-meter .strength-meter-fill[data-strength=\"2\"]{background:orange;width:60%}.strength-meter .strength-meter-fill[data-strength=\"3\"]{background:#9acd32;width:80%}.strength-meter .strength-meter-fill[data-strength=\"4\"]{background:green;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./core/password-strength-validator/password-strength-validator.useable.scss
// module id = 332
// module chunks = 0